var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"d-flex justify-center",attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"white--text px-10",attrs:{"disabled":_vm.disabled,"color":"grey"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" 조회 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }